import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Logo = _resolveComponent("Logo")
  const _component_Badge = _resolveComponent("Badge")

  return (_openBlock(), _createBlock(_component_Badge, {
    open: $props.open,
    class: _normalizeClass(["badge", {flat: $props.flat, genrate: $options.genrate}]),
    relative: "",
    icon: $options.icon,
    "icon-color": $props.flat ? $options.agent.color : 'var(--gray-600)',
    "border-color": "var(--gray-600)",
    color: $props.flat ? $options.agent.color : 'var(--gray-700)',
    style: _normalizeStyle({border: '0.1rem solid var(--gray-200)', background: $props.flat ? 'transparent' : $options.agent.bg }),
    rounded: false
  }, {
    default: _withCtx(() => [
      ($props.type === 'genrate')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_Logo, {
              class: "logo",
              size: "1.6rem"
            }),
            _createElementVNode("span", null, _toDisplayString($options.agent.text), 1 /* TEXT */)
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString($options.agent.text), 1 /* TEXT */)
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["open", "class", "icon", "icon-color", "color", "style"]))
}